import { useModal } from '@/storybook/modal/useModal';
import AddRequestContentModal from '../components/modal/AddRequestContentModal.vue';
import EditRequestContentModal from '../components/modal/EditRequestContentModal.vue';
import type { RequestContent } from '../types';

interface ModalProps {
  domain: string;
  onSave: (item: RequestContent) => void;
}

interface EditModalProps extends ModalProps {
  item: RequestContent;
}

export const useRequestContentModals = () => {
  const showAddModal = (props: ModalProps) => {
    const { open, close } = useModal(AddRequestContentModal, {
      modalProps: {
        domain: props.domain,
        onSave: (item: RequestContent) => {
          props.onSave(item);
          // Don't close automatically - let the modal show success screen first
        },
        onClose: () => {
          close();
        },
      },
      dataTestid: 'add-request-content-modal-layout',
    });

    return open();
  };

  const showEditModal = (props: EditModalProps) => {
    const { open, close } = useModal(EditRequestContentModal, {
      modalProps: {
        item: props.item,
        domain: props.domain,
        onSave: (item: RequestContent) => {
          props.onSave(item);
          // Don't close automatically - let the modal show success screen first
        },
        onClose: () => {
          close();
        },
      },
      dataTestid: 'edit-request-content-modal-layout',
    });

    return open();
  };

  return {
    showAddModal,
    showEditModal,
  };
};
